import { CatalogItem } from "@common/types/catalogItem";
import {
    buildCatalogItemLinePatch,
    toCatalogItemSelection,
} from "@components/invoices/NativeInvoiceDrawer/catalogItemSelection.helpers";
import { NativeInvoiceLineRow } from "@components/invoices/NativeInvoiceDrawer/nativeInvoiceFormTypes";

function normalizedName(name: string): string {
    return name.trim().toLowerCase();
}

export function suggestedCatalogItem({
    items,
    line,
}: {
    items: readonly CatalogItem[];
    line: NativeInvoiceLineRow;
}): CatalogItem | null {
    const name = normalizedName(line.productOrService);
    if (line.catalogItemId || !name) {
        return null;
    }
    return (
        items.find(
            (item) => item.active && normalizedName(item.name) === name,
        ) ?? null
    );
}

export function acceptedCatalogItemPatch({
    line,
    item,
}: {
    line: NativeInvoiceLineRow;
    item: CatalogItem;
}): Partial<NativeInvoiceLineRow> {
    const selection = toCatalogItemSelection(item);
    return {
        ...buildCatalogItemLinePatch(selection),
        description: item.description ?? line.description,
        classIds:
            selection.classIds.length > 0 ? selection.classIds : line.classIds,
        receivablesAccountId:
            item.receivablesAccountId ?? line.receivablesAccountId,
    };
}
